"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sewage = function Sewage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 24 24", className: "custom-icon" }, props),
    _react2.default.createElement("path", {
      d: "M22,21.999659 C22,21.999659 21.6206222,16.1465169 19.2507333,12.8413173 C18.2886,11.4989849 16.7857556,10.7816195 15.3398667,10.4031616 C15.5723333,9.35166215 15.6974889,8.1388919 15.6974889,6.87600155 C15.6974889,5.11293297 15.4547556,3.44533127 15.0142667,2.18073615 C14.5244,0.774645486 13.8355556,0 13.0746,0 C13.0533333,0 13.0323111,0.00306857807 13.0112889,0.00443239055 L13.0112889,0 L2.62264444,0 C1.86168889,0 1.1726,0.774304533 0.682733333,2.18073615 C0.242488889,3.44499031 0,5.11259202 0,6.8756606 C0,8.63907013 0.242488889,10.3066718 0.682977778,11.570926 C1.17284444,12.9770167 1.86168889,13.7516621 2.62288889,13.7516621 L13.0115333,13.7516621 L13.0115333,13.7479117 C13.0325556,13.7489345 13.0535778,13.7520031 13.0748444,13.7520031 C13.4527556,13.7520031 13.8133111,13.5600465 14.1398889,13.1955676 C14.6339111,13.5747075 15.0482444,14.268888 15.0482444,15.5297327 C15.0482444,18.6593413 15.0482444,22 15.0482444,22 L22,22 L22,21.999659 Z M13.0746,1.23425029 C13.8964222,1.23425029 14.8123556,3.55102673 14.8123556,6.8756606 C14.8123556,8.16412243 14.6747333,9.29983727 14.4584,10.2095002 C13.2628222,9.99469973 12.2004667,9.98447114 11.6431333,9.99981403 C11.4546667,9.12731499 11.3363556,8.06695079 11.3363556,6.8756606 C11.3366,3.55102673 12.2525333,1.23425029 13.0746,1.23425029 Z M2.62264444,12.5177528 C1.80057778,12.5177528 0.884644444,10.2002945 0.884644444,6.8756606 C0.884644444,3.55102673 1.80057778,1.23425029 2.62264444,1.23425029 L11.4810667,1.23425029 C11.3334222,1.50735374 11.1960444,1.82375823 11.0716222,2.1803952 C10.6311333,3.44499031 10.3884,5.11259202 10.3884,6.8756606 C10.3884,8.63907013 10.6311333,10.3066718 11.0716222,11.570926 C11.1960444,11.9279039 11.3331778,12.2443084 11.4810667,12.5174119 L2.62264444,12.5174119 L2.62264444,12.5177528 Z",
      id: "path-1"
    })
  );
};

exports.default = Sewage;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/waterandsewage.js
// module id = ../lib/egov-ui-kit/custom-icons/waterandsewage.js
// module chunks = 504